<div class="ngx-gallery-thumbnails-wrapper ngx-gallery-thumbnail-size-{{ size }}">
  <div
    class="ngx-gallery-thumbnails"
    [style.left]="thumbnailsLeft"
    [style.marginLeft]="thumbnailsMarginLeft"
  >
    <a
      [href]="hasLinks() ? links[i] : '#'"
      [target]="linkTarget"
      class="ngx-gallery-thumbnail"
      *ngFor="let image of getImages(); let i = index"
      (click)="handleClick($event, i)"
      [style.width]="getThumbnailWidth()"
      [style.height]="getThumbnailHeight()"
      [style.left]="getThumbnailLeft(i)"
      [style.top]="getThumbnailTop(i)"
      [style.border]="getBorderStyle(i)"
      [ngClass]="{ 'ngx-gallery-active': i == selectedIndex, 'ngx-gallery-clickable': clickable }"
    >
      <ng-container [ngSwitch]="image.extension">
        <div *ngSwitchCase="'pdf'" class="ngx-gallery-thumbnail-png">
          <div class="pdf-text-info">PDF File, expand for more details</div>
          <pdf-viewer
            [src]="image.url"
            [show-all]="false"
            [original-size]="false"
            [autoresize]="true"
            [page]="1"
            [fit-to-page]="false"
            [render-text]="false"
            style="display: block"
          ></pdf-viewer>
        </div>
        <img *ngSwitchDefault [src]="image.url" class="ngx-gallery-thumbnail-img" />
        <!--<img  src="images/pdf_icon.pdf" class="ngx-gallery-thumbnail-img" />-->
      </ng-container>
      <div
        *ngIf="image.leftIcon"
        class="ngx-gallery-icons-wrapper-left"
        [style.background-color]="image.leftIcon.colour"
      >
        <i
          class="ngx-gallery-icon {{ image.leftIcon.name }}"
          aria-hidden="true"
          title="{{ image.leftIcon.title }}"
        >
        </i>
      </div>
      <div class="ngx-gallery-icons-wrapper">
        <ngx-gallery-action
          *ngIf="showDownloadOnAction"
          icon="material-icons download"
          (onClick)="handleDownload($event, i)"
        ></ngx-gallery-action>
        <ngx-gallery-action
          *ngIf="showPreviewOnAction"
          icon="fa fa-search"
          (onClick)="handleShowPreview($event, i)"
        ></ngx-gallery-action>
        <ngx-gallery-action
          *ngFor="let action of actions"
          [icon]="action.icon"
          [disabled]="action.disabled"
          [titleText]="action.titleText"
          (onClick)="action.onClick($event, i)"
        ></ngx-gallery-action>
      </div>
      <div
        class="ngx-gallery-remaining-count-overlay"
        *ngIf="remainingCount && remainingCountValue && i == columns - 1"
      >
        <span class="ngx-gallery-remaining-count">+{{ remainingCountValue }}</span>
      </div>
    </a>
  </div>
</div>
<!--<ngx-gallery-arrows *ngIf="canShowArrows()" (onPrevClick)="moveLeft()" (onNextClick)="moveRight()" [prevDisabled]="!canMoveLeft()" [nextDisabled]="!canMoveRight()" [arrowPrevIcon]="arrowPrevIcon" [arrowNextIcon]="arrowNextIcon"></ngx-gallery-arrows>-->
